import * as yup from 'yup';
import { RendererType } from '../../../data-models/field-definition';
import { schemaToFormFields } from '../../../util/schema-utils';

/**
 * Deal pass/miss reason config schema. A reason is a single named, sortable
 * item, so the config form is one required "Name" text field bound to `reason`.
 */
export function dealReasonConfigFormSchema() {
  return yup.object({
    reason: yup
      .string()
      .required()
      .label('Name')
      .formMeta({
        renderer: RendererType.text,
        rendererMeta: { maxLength: -1 },
      }),
  });
}

export function getDealReasonFields() {
  return schemaToFormFields(dealReasonConfigFormSchema(), ['reason']);
}
